document.addEventListener("DOMContentLoaded", function () {
  // DOM取得
  const toggleButton = document.querySelector(".new_product_detail_button_showroom");
  const popup = document.querySelector(".area-container");
  const overlay = document.querySelector(".popup-overlay");
  const areaList = document.querySelector(".area-list");
  const showroomList = document.querySelector(".showroom-list");
  const backButton = document.querySelector(".back-button");
  const areaButtons = document.querySelectorAll(".area-button");
  const activeAreaButtons = document.querySelectorAll(".active-area-button");
  const showroomItems = document.querySelectorAll(".showroom-item");

  console.log("activeAreaButtons count:", activeAreaButtons.length);

  // 初期状態の設定
  function resetPopupState() {
    console.log("Resetting to area-list view");
    areaList.classList.add("active");
    showroomList.classList.remove("active");
  }

  function openPopup() {
    console.log("Open popup");
    popup.style.display = "block";
    const rect = popup.getBoundingClientRect();
    const isVisible = (
      rect.top >= 0
      && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
    if (!isVisible) {
      popup.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    }
    resetPopupState();
  }

  function closePopup() {
    console.log("Close popup");
    popup.style.display = "none";
    overlay.style.display = "none";
  }

  // ポップアップ開閉
  toggleButton?.addEventListener("click", () => {
    if (popup.style.display === "block") {
      closePopup();
    } else {
      openPopup();
    }
  });

  overlay?.addEventListener("click", closePopup);
  backButton?.addEventListener("click", resetPopupState);

  // エリアボタン → showroom-list 表示切替
  activeAreaButtons.forEach(button => {
    button.addEventListener("click", () => {
      console.log("エリアボタンクリックされました！");
      areaList.classList.remove("active");
      showroomList.classList.add("active");
    });
  });

  // ショールーム表示切替 + ボタン色切替
  areaButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const selectedArea = this.getAttribute("data-area");
      showroomItems.forEach((item) => {
        item.style.display = item.getAttribute("data-area") === selectedArea ? "block" : "none";
      });
      areaButtons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");
      backButton.style.display = "flex";
    });
  });

  // 戻るボタン
  backButton?.addEventListener("click", function () {
    showroomItems.forEach(item => item.style.display = "block");
    areaButtons.forEach(btn => btn.classList.remove("active"));
    // backButton.style.display = "none"; // 必要なら戻す
  });

  // 優先度による並び替え
  const container = document.querySelector(".showroom-list");
  const items = Array.from(document.querySelectorAll(".showroom-item"));
  items.sort((a, b) => parseInt(a.dataset.recommend, 10) - parseInt(b.dataset.recommend, 10));
  items.forEach(item => container.appendChild(item));

});
